import { OkrKeyResultUpdate } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setOkrKeyResultUpdateList = (updateList: types.OkrKeyResultUpdateList) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_UPDATE_LIST),
    updateList,
})
export const setOkrKeyResultUpdateEdit = (update: OkrKeyResultUpdate) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_UPDATE_EDIT),
    update,
})


export const setOkrKeyResultUpdateReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_UPDATE_RELOAD_EDIT),
    value,
})
